import {Action, ReducerBuilder} from "redux-ts";
import {Reducer} from "platform/redux/Reducer";
import {OnLoggedOut} from "core/redux/auth/AuthReduxActions";
import Platform from "platform/Platform";
import {ServiceType} from "enum/ServiceType";
import {NewsReduxState} from "core/redux/news/NewsReduxState";
import NewsEngine from "core/engine/NewsEngine";
import {DoFetchNewsType, SetNews, SetNewsPayload, SetSelectedNewsId, SetSelectedNewsIdPayload} from "core/redux/news/NewsReduxActions";

const initialState = (): NewsReduxState => {
    return {
        news: []
    };
};

export default class NewsReducer extends Reducer<NewsReduxState> {

    private static _instance: NewsReducer;

    public static instance(): NewsReducer {
        return this._instance || (this._instance = new this());
    }

    private constructor() {
        super();
        const newsEngine: NewsEngine = Platform.engine(ServiceType.News);
        this._middlewareActions.set(DoFetchNewsType, newsEngine.doFetchNews);
    }

    public get name(): string {
        return "news";
    }

    protected setup(builder: ReducerBuilder<NewsReduxState>): void {
        builder
            .init(initialState())
            .handle(OnLoggedOut, (state: NewsReduxState, action: Action<any>) => {
                return {
                    ...initialState()
                };
            })
            .handle(SetNews, (state: NewsReduxState, {payload}: Action<SetNewsPayload>) => {
                return Object.assign({}, state, {
                    news: payload.news,
                });
            })
            .handle(SetSelectedNewsId, (state: NewsReduxState, {payload}: Action<SetSelectedNewsIdPayload>) => {
                return Object.assign({}, state, {
                    selectedNewsId: payload.id
                });
            });
    }
}
